import { Component, Input, OnInit } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'portfolio-table-skeleton',
	templateUrl: './portfolio-table-skeleton.component.html',
	styleUrls: ['./portfolio-table-skeleton.component.scss']
})
export class PortfolioTableSkeletonComponent implements OnInit {
	@Input() public showTitle: boolean = true;
	@Input() public isFullScreenList: boolean = true;

	public ghostArray: Array<number>;

	public ngOnInit(): void {
		this.ghostArray = this.isFullScreenList ? new Array(10) : new Array(5);
	}
}
